import { computed } from 'vue'
import { rawDynamicImport } from '@app/helpers/memberships/section'
import { generateFieldValidationRules } from '@app/helpers/memberships/fields'
import { data } from '@app/booking/state/store'

export default function(validate, form){
    return {
        title     : 'Attendees',
        component : rawDynamicImport(() => import('@app/booking/components/form/stages/attendees/Attendees.vue')),
        isValid   : computed(
            () => form.value.ticket.people.every(
                (person) => validate(
                    {
                        ...generateFieldValidationRules(data.event.details.value?.fields ?? []),
                        forename : ['required'],
                        surname  : ['required'],
                        email    : ['required', 'email']
                    }, 
                    person
                )
            )
        ),
        data: computed(
            () => ({
                ticket: {
                    people: form.value.ticket.people
                }
            })
        ),
    }
}